import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = [
    "checkbox", "selectAll", "selectedCount", "typeCheckbox", "allTypes"
  ]
  static values = { selectedCount: Number, maximum: Number }

  declare readonly checkboxTargets: HTMLInputElement[]
  declare readonly hasSelectAllTarget: boolean
  declare readonly selectAllTarget: HTMLInputElement
  declare readonly hasSelectedCountTarget: boolean
  declare readonly selectedCountTarget: HTMLElement
  declare readonly typeCheckboxTargets: HTMLInputElement[]
  declare readonly hasAllTypesTarget: boolean
  declare readonly allTypesTarget: HTMLInputElement
  declare readonly selectedCountValue: number
  declare readonly maximumValue: number

  private initialCheckedCount = 0

  connect() {
    this.initialCheckedCount = this.checkboxTargets.filter((checkbox) => checkbox.checked).length
    this.refresh()
  }

  toggleOne() {
    this.refresh()
  }

  toggleAll(event: Event) {
    const checked = (event.currentTarget as HTMLInputElement).checked
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })
    this.refresh()
  }

  toggleAllTypes(event: Event) {
    if (!(event.currentTarget as HTMLInputElement).checked) return

    this.typeCheckboxTargets.forEach((checkbox) => { checkbox.checked = false })
  }

  toggleOneType() {
    if (this.hasAllTypesTarget) {
      this.allTypesTarget.checked = !this.typeCheckboxTargets.some((checkbox) => checkbox.checked)
    }
  }

  validate(event: SubmitEvent) {
    if (!event.submitter?.dataset.emailCampaignTargetsValidateRecipientCount) return

    const count = this.currentSelectedCount
    if (count === 0) {
      event.preventDefault()
      this.showToast("配信対象を1件以上選択してください")
    } else if (count > this.maximumValue) {
      event.preventDefault()
      this.showToast(`配信対象は${this.maximumValue}件まで選択できます`)
    }
  }

  refresh() {
    const count = this.currentSelectedCount
    if (this.hasSelectedCountTarget) this.selectedCountTarget.textContent = count.toString()
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked =
        this.checkboxTargets.length > 0 && this.checkboxTargets.every((checkbox) => checkbox.checked)
    }
  }

  showToast(message: string) {
    window.dispatchEvent(new CustomEvent("toast:show", { detail: { message } }))
  }

  get currentSelectedCount() {
    const checkedOnPage = this.checkboxTargets.filter((checkbox) => checkbox.checked).length
    return this.selectedCountValue - this.initialCheckedCount + checkedOnPage
  }
}
